module.exports = __webpack_public_path__ + "media/images/icon_interact-488c17f93b9fd3d4511e6019326e16fb.png";